import { createStore, applyMiddleware, combineReducers } from "redux";
import Immutable from "seamless-immutable";
import createSagaMiddleware from "redux-saga";
import { createWhitelistFilter } from "redux-persist-transform-filter";
import { createTransform } from "redux-persist";
import rootSaga from "../../src/saga/index";
import { rootReducers } from "../reducers";
const SetTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState, key) => {
    // convert mySet to an Array.
    return { ...inboundState };
  },
  // transform state being rehydrated
  (outboundState, key) => {
    if (outboundState) {
      outboundState.mergeDeep = (x) => x;
    }
    return Immutable(outboundState);
  },
);

// If you don't bother about the error redux-persist failed to create sync storage. falling back to noop storage...uncomment the next line and comment out the previous import. See more on - https://github.com/vercel/next.js/discussions/15687
const storage = require("redux-persist/lib/storage").default;

//COMBINING ALL REDUCERS

// BINDING MIDDLEWARE
const bindMiddleware = (middleware) => {
  // if (process.env.NODE_ENV !== "production") {
  //   const { composeWithDevTools } = require("redux-devtools-extension");
  //   return composeWithDevTools(applyMiddleware(...middleware));
  // }
  return applyMiddleware(...middleware);
};

const { persistStore, persistReducer } = require("redux-persist");
const sagaMiddleware = createSagaMiddleware();

const saveSubsetUserListMovement = createWhitelistFilter("user", ["user"]);
const saveSubsetMovementListMovement = createWhitelistFilter("movement", ["list"]);
const saveSubsetPaymentListMovement = createWhitelistFilter("payment", ["amount"]);
const saveSubsetWithdrawListMovement = createWhitelistFilter("withdraw", ["withdrawData"]);
const saveSubsetWithdrawListIPO = createWhitelistFilter("ipo", ["data"]);

const persistConfig = {
  key: "root",
  whitelist: ["user",'movement','payment','withdraw','ipo'], // only counter will be persisted, add other reducers if needed
  storage,
  transforms: [SetTransform, saveSubsetUserListMovement,saveSubsetMovementListMovement,saveSubsetPaymentListMovement,saveSubsetWithdrawListMovement,saveSubsetWithdrawListIPO],
};

const persistedReducer = persistReducer(persistConfig, rootReducers); // Create a new reducer with our existing reducer
export const store = createStore(persistedReducer, bindMiddleware([sagaMiddleware])); // Creating the store again
store.sagaTask = sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);
